import script from "./BasicTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicTitle.vue?vue&type=script&setup=true&lang=js"

import "./BasicTitle.vue?vue&type=style&index=0&id=1659b61e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1659b61e"]])

export default __exports__